import React, {useEffect} from 'react'
import {observer} from 'mobx-react'
import ViewerHistory from './Viewer.history'
import ViewerWorkspace from './Viewer.workspace'
import ViewerToolbar from './Toolbar/Viewer.toolbar'
import styled from 'styled-components'
import ViewerStore from './Viewer.store'


export default observer((props) => {
    const storeViewer = new ViewerStore()

	console.log('init viewer',props.attributes)

    //Инициализация состояния
    useEffect(async () => {
        storeViewer.setMode(props.mode)
        await storeViewer.setAttributes(props.attributes)
        await storeViewer.setHistory(props.history)
        storeViewer.setCount(props.count)
        storeViewer.setTimer(props.timer)
    }, [props.history, props.attributes])

    return (
        <Viewer>
            <ViewerToolbar store={storeViewer}/>
            <ViewerWrapper right={props.right}>
                <ViewerWorkspace store={storeViewer}/>
                <ViewerHistory store={storeViewer}/>
            </ViewerWrapper>
        </Viewer>
    )
})

const Viewer = styled.div`
  width: 100%;
  height: 100%;
  background: black;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  transition: 500ms;
`

const ViewerWrapper = styled.div`
  position: absolute;
  top: 120px;
  bottom: 0;
  left: 90px;
  right: ${(p) => p.right}px;
  display: flex;
  flex-direction: column;
  background: black;
`
